import { render, staticRenderFns } from "./HiddenColumnsModal.vue?vue&type=template&id=b14106ca"
import script from "./HiddenColumnsModal.vue?vue&type=script&lang=js"
export * from "./HiddenColumnsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports